import { useAtom } from "jotai";
import Slider from "rc-slider";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import anime from "animejs/lib/anime.es.js";
import { videoState, loading } from "@stores/vars";
import playSound from "@/sound";

const Wrap = styled.div`
  position: absolute;
  left: 0;
  top: 175px;
  width: 100%;
  height: calc(100% - 175px);
`;

const VideoWrap = styled.div`
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  height: 855px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
`;

const ControllerBar = styled.div`
  position: absolute;
  left: 80px;
  bottom: 25px;
  width: 1760px;
  height: 115px;
  background-color: #2d2a48;
  border-radius: 50px;
  animation: slideUp 0.8s cubic-bezier(0.65, 0, 0.35, 1);
  animation-delay: 0.5;
  z-index: 10;
`;

const SliderWrap = styled.div`
  width: 885px;
  position: absolute;
  left: 550px;
  top: 40px;
  height: 40px;
`;

const SwapButton = styled.button`
  position: absolute;
  left: -4px;
  top: -3px;
  width: 241px;
  height: 120px;
  background: url(${require("@assets/img/icon_animation_swap2.png")}) no-repeat;
`;

const PlayerToggleButton = styled.button`
  display: inline-block;
  width: 55px;
  height: 55px;
  left: 317px;
  top: 31px;
  position: absolute;
  background: url(${require("@assets/img/icon_sound_play.png")}) no-repeat;
  background-size: 100%;
  &.pause {
    background: url(${require("@assets/img/icon_sound_pause.png")}) no-repeat;
    background-size: 100%;
  }
`;

const StopButton = styled.button`
  display: inline-block;
  width: 55px;
  height: 55px;
  left: 415px;
  top: 31px;
  position: absolute;
  background: url(${require("@assets/img/icon_sound_stop.png")});
  background-size: 100%;
`;

const LangButtonWrap = styled.div`
  display: flex;
  position: absolute;
  right: 10px;
  width: 310px;
  justify-content: space-evenly;
`;

const LangButton = styled.button`
  padding: 40px 10px;
  font-size: 29px;
  color: #fff;
  top: 0;
  opacity: 0.5;
  &.on {
    opacity: 1;
  }
`;

const BookVideo = ({ data, onSwap }) => {
  const playerRef = useRef();
  const isDraging = useRef(false);
  const videoWrapRef = useRef(null);
  const [currentSeek, setSeek] = useState(0);
  const [isPlay, setPlay] = useAtom(videoState);
  const [curVieo, setvideo] = useState(data.mov?.ko ? "ko" : "cn");
  // 테블릿 비디오 URL 예외처리
  const videoURL =
    window.location.protocol.indexOf("http") > -1
      ? `./vdo/${data.mov[curVieo]}`
      : `/storage/emulated/0/Android/data/com.daekyo.caihongstory/files/Pictures/${data.mov[curVieo]}`;

  const onSoundError = () => {
    window.alert("video error!");
    loading(false);
  };
  const onSoundEnded = () => {
    onClickStop();
  };

  const onChange = (value) => {
    setSeek(value);
  };

  // slider callbacks
  const onBeforeChange = (value) => {
    isDraging.current = true;
  };

  const onAfterChange = (value) => {
    isDraging.current = false;
    playerRef.current.seekTo(value / 100);
    loading();
    setSeek(value);
  };

  const onReady = () => {
    loading(false);
    anime({
      targets: videoWrapRef.current,
      opacity: 1,
      duration: 1000,
      easing: "linear",
    });
  };

  const onSoundProgress = (value) => {
    const { played } = value;
    if (isDraging.current === false) {
      setSeek(played * 100);
    }
  };

  // player controls button
  const onClickPlayToggle = () => {
    setPlay(!isPlay);
  };

  const onClickStop = () => {
    setPlay(false);
    setSeek(0);
    playerRef.current.seekTo(0);
  };

  useEffect(() => {
    loading();
  }, [curVieo]);

  useEffect(() => {
    if (isPlay) {
      playSound.bgm(null);
    }
  }, [isPlay]);

  useEffect(() => {
    setPlay(true);
    loading();
    return () => {
      setPlay(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap>
      <VideoWrap ref={videoWrapRef}>
        <ReactPlayer
          progressInterval={1000}
          ref={playerRef}
          width="auto"
          height="100%"
          playing={isPlay}
          pip={false}
          volume={1}
          loop={false}
          controls={false}
          onReady={onReady}
          onEnded={onSoundEnded}
          onError={onSoundError}
          onProgress={onSoundProgress}
          url={videoURL}
        />
      </VideoWrap>
      <ControllerBar>
        <PlayerToggleButton
          type="button"
          className={isPlay === true ? "play pause" : "pay"}
          onClick={onClickPlayToggle}
        />
        <StopButton type="button" onClick={onClickStop} className="stop" />
        <SliderWrap>
          <Slider
            className={""}
            onAfterChange={onAfterChange}
            min={0}
            max={100}
            onBeforeChange={onBeforeChange}
            onChange={onChange}
            value={currentSeek}
            step={0}
          />
        </SliderWrap>
        <SwapButton onClick={() => onSwap("book")} />
        <LangButtonWrap>
          {Object.keys(data.mov).map((lang, i) => {
            return (
              <LangButton
                key={i}
                className={`lang-${lang} ${lang === curVieo ? "on" : ""}`}
                type="button"
                onClick={() => {
                  setvideo(lang);
                }}
              >
                {lang === "cn" ? "중국어" : lang === "en" ? "영어" : "한국어"}
              </LangButton>
            );
          })}
          {/* <LangButton
            className={curVieo === "cn" ? "lng-cn on" : "lng-cn"}
            type="button"
            onClick={() => {
              setvideo("cn");
            }}
          >
            중국어
          </LangButton>
          <LangButton
            className={curVieo === "en" ? "lng-en on" : "lng-en"}
            type="button"
            onClick={() => {
              setvideo("en");
            }}
          >
            영어
          </LangButton> */}
        </LangButtonWrap>
      </ControllerBar>
    </Wrap>
  );
};

export default BookVideo;
